import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { LoadingAnimation } from '../../../components/LoadingAnimation'
import './index.scss'

interface Props {
  currentCompanyStore: CurrentCompanyStore
}

@inject('currentCompanyStore')
@observer
export class DashboardInventory extends React.Component<React.PropsWithChildren<Props>, {}> {
  componentDidMount() {
    this.props.currentCompanyStore!.getLocations()
  }

  render() {
    const locations = this.props.currentCompanyStore!.locations

    if (locations === undefined) {
      return <LoadingAnimation />
    } else if (locations.length === 0) {
      return (
        <div>
          <div className='card card-warning mb-2' style={{ color: 'white' }}>
            <div className='card-body'>
              <h3 className='card-text'>You have not added any locations yet</h3>
              <p className='card-text'>Inventory is assigned on a per-location basis.</p>
              <p className='card-text'>
                Select 'Company' on the left navigation menu to add locations for your business.
              </p>
            </div>
          </div>
        </div>
      )
    } else {
      return <div className='full-view'>{this.props.children}</div>
    }
  }
}
